<template>
    <!-- Produktauflistung standalone  -->
    <div v-if="flagNurProdukte" class="shop-the-look-darstellung shop-the-look-standalone">
        <div class="shop-body" :data-d-hi="herkunft_intern">
            <artikel
                v-for="artikel in artikellisteSortiert"
                v-bind:artikel="artikel"
                v-bind:optionen="optionen"
                v-bind:key="artikel.ArtikelNr"
                v-on:aktualisieren-einkaufstasche="aktualisierenEinkaufstasche"
            />
        </div>
        <div class="footer-einkaufstasche" v-if="flagShop">
            <div class="gesamtpreis">{{ SummePreis }}: <span v-html="waehrung"></span> {{ holenGesamtPreisDarstellung }}</div>
            <p v-html="mwst" class="mwst"></p>
            <div v-if="gesamtPreisAlleArtikel !== 0">
                <a v-on:click="vueInDieTasche" class="btn btn-red wk-popup cta-button">
                    <i class="icons8-shopping-bag-filled"></i> <span> {{ Cta_Button }}</span>
                </a>
            </div>
        </div>
    </div>
    <!-- �berschrift, Text und Produktauflistung  -->
    <div v-else class="container container-xl-75">
        <div class="row shop-the-look-darstellung">
            <div class="col-12 col-md-6 shop-the-look-header">
                <h1>{{ Ueberschrift }}</h1>
                <h2>{{ Subline }}</h2>
            </div>
        </div>
        <div class="row shop-the-look-darstellung">
            <div class="col-12 col-md-6 col-lg-6 col-xl-6 linke-row order-2 order-md-1">
                <img alt="Darstellung des Shop the Look-Models" :class="'img-grandel img-fluid img-' + Bildklasse" :src="Bild" :alt="Ueberschrift">
                <div class="produktext mt-4" v-html="produkt_text"></div>
            </div>
            <div class="col-12 col-md-5 col-lg-5 col-xl-5 offset-md-1 rechte-row order-1 order-md-2">
                <div class="shop-body" :data-d-hi="herkunft_intern">
                    <artikel
                        v-for="artikel in artikellisteSortiert"
                        v-bind:artikel="artikel"
                        v-bind:optionen="optionen"
                        v-bind:key="artikel.ArtikelNr"
                        v-on:aktualisieren-einkaufstasche="aktualisierenEinkaufstasche"
                    />
                </div>
                <div class="footer-einkaufstasche" v-if="flagShop">
                    <div class="gesamtpreis">{{ SummePreis }}: <span v-html="waehrung"></span> {{ holenGesamtPreisDarstellung }}</div>
                    <p v-html="mwst" class="mwst"></p>
                    <div v-if="gesamtPreisAlleArtikel !== 0">
                        <a v-on:click="vueInDieTasche" class="btn btn-red wk-popup cta-button">
                            <i class="icons8-shopping-bag-filled"></i> <span> {{ Cta_Button }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Artikel from './components/Artikel.vue';
    export default {
        name: 'app',
        components: {
            Artikel
        },
        props: {
            optionen: Object,
            produktDaten: Array,
            texte: Object,
        },
        data () {
            return {
                Ueberschrift: this.optionen.ueberschrift,
                Subline: this.optionen.subline,
                Bild: this.optionen.modelBild,
                Bildklasse: this.optionen.modelBildklasse,
                waehrung: this.optionen.waehrung,
                id_produkt_look: this.optionen.id_produkt_look,
                herkunft_intern: this.optionen.herkunft_intern,
                artikelliste: [],
                einkaufstascheSet: {},
                SummePreis: this.optionen.texte.gesamtpreis,
                Cta_Button: this.optionen.texte.cta_button,
                produkt_text: this.optionen.texte.produkt_text,
                mwst: this.optionen.texte.mwst_versandkosten,
                gesamtPreisAlleArtikel: 0,
                modelHintergrund: this.optionen.modelHintergrund,
                flagShop: this.optionen.flagShop,
                flagNurProdukte: this.optionen.flagNurProdukte,
            }
        },
        methods: {
            holenGesamtPreis() {
                var gesamtPreisArtikel = 0;
                var aktuellerPreisArtikel = 0;
                var menge = 0;
                this.gesamtPreisAlleArtikel = 0;
                for (let produkt in this.einkaufstascheSet) {
                    aktuellerPreisArtikel = this.einkaufstascheSet[produkt].preis;
                    aktuellerPreisArtikel = parseFloat(aktuellerPreisArtikel.replace(/\,/, "."));
                    menge = this.einkaufstascheSet[produkt].menge;
                    gesamtPreisArtikel = menge*aktuellerPreisArtikel;
                    this.gesamtPreisAlleArtikel += gesamtPreisArtikel;
                }
            },
            holeArtikel() {
                this.$http.get(this.optionen.ajaxUrl).then(response => {
                    if (response.status === 200) {
                        this.artikelliste = response.body;
                        this.setztenDatenEinkaufstasche(this.artikelliste);
                        this.holenGesamtPreis();
                    }
                }, response => {
                    if (response.status && response.statusText) {
                        console.error(`Es ist ein Fehler aufgetreten: ${response.status} - ${response.statusText}`);
                        this.wiederholenProduktRequest();
                    } else {
                        console.error(`Es ist ein Fehler aufgetreten: ${response}`);
                    }
                });
            },
            vueInDieTasche() {
                var artikelEinkaufstasche = [];
                this.artikelliste.forEach((artikel) => {
                    if (this.einkaufstascheSet[artikel.ID_PRODUKT]['menge']) {
                        artikelEinkaufstasche.push({
                            'ID_PRODUKT': artikel.ID_PRODUKT,
                            'ANZAHL': this.einkaufstascheSet[artikel.ID_PRODUKT]['menge'],
                            'HERKUNFT': 'shop_the_look'
                        })
                    }
                });
                return inDieTasche({'ID_PRODUKT': this.id_produkt_look, 'ANZAHL': 1, 'JSON': JSON.stringify(artikelEinkaufstasche)});
            },
            aktualisierenEinkaufstasche(daten) {
                var anzahl = parseInt(daten.menge);
                anzahl = this.$set(this.einkaufstascheSet[daten.artikelId], 'menge', anzahl);
                this.holenGesamtPreis();
            },
            setztenDatenEinkaufstasche(artikelliste) {
                artikelliste.forEach((artikel) => {
                    this.einkaufstascheSet[artikel.ID_PRODUKT] = {};
                    this.einkaufstascheSet[artikel.ID_PRODUKT]['preis'] = artikel.PREIS;
                    this.einkaufstascheSet[artikel.ID_PRODUKT]['menge'] = artikel.MENGE || 1;
                });
            },
            initialisierenArtikelProps() {
                this.artikelliste = this.produktDaten;
                this.setztenDatenEinkaufstasche(this.artikelliste);
                this.holenGesamtPreis();
            }
        },
        computed: {
            holenGesamtPreisDarstellung() {
                return this.gesamtPreisAlleArtikel.toFixed(2).replace(/\./, ",");
            },
            artikellisteSortiert() {
                let artikellisteSortiert = this.artikelliste.sort((artikelA, artikelB) => {
                    if (artikelA.FLAG_AKTIV && !artikelB.FLAG_AKTIV) {
                        return -1;
                    }
                    if (!artikelA.FLAG_AKTIV && artikelB.FLAG_AKTIV) {
                        return 1;
                    }
                    return 0;
                });

                return artikellisteSortiert;
            }
        },
        mounted() {
            if (this.produktDaten != null && typeof this.produktDaten != 'undefined') {
                this.initialisierenArtikelProps();
            } else {
                this.holeArtikel();
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/App.vue